import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterS: any = null,
    sceneTextLeaveS: any = null;
export default function S() {
    const { useLang, useRouter, useEffect, useState, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const LOCAL_SITES: string[] = ['jp'];

    const cards: any[] = [
        {
            img: `/responsive/picture/delta-pro-ultra/launch/19_1_1${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.png`,
            text: t('secS_app_monitor'),
        },
        {
            img: `/responsive/picture/delta-pro-ultra/launch/19_1_2${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.png`,
            text: t('secS_app_control'),
        },
        {
            img: `/responsive/picture/delta-pro-ultra/launch/19_1_3${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.png`,
            text: t('secS_app_customize'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterS) {
                    AniContainer.removeScene(sceneTextEnterS);
                    sceneTextEnterS = null;
                }
                if (sceneTextLeaveS) {
                    AniContainer.removeScene(sceneTextLeaveS);
                    sceneTextLeaveS = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterS = AniContainer.create({
                    triggerElement: '.dpu-detail-S .text-info',
                    triggerHook: 1,
                    offset: startH, //isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    duration: 200, //window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
                // sceneTextLeaveS = AniContainer.create({
                //     triggerElement: '.dpu-detail-S .text-info',
                //     triggerHook: 1,
                //     offset: 0,
                //     duration: window.innerHeight * 2,
                //     onLeave: () => setTextEnter(false),
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterS) {
                    AniContainer.removeScene(sceneTextEnterS);
                    sceneTextEnterS = null;
                }
                if (sceneTextLeaveS) {
                    AniContainer.removeScene(sceneTextLeaveS);
                    sceneTextLeaveS = null;
                }

                //window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-S dpu-detail-section ${css['dpu-detail-S']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h2 className="title">{t('secS_title')}</h2>
                <p className="desc">
                    {t.rich('secS_desc', {
                        w: (text: string) => <span className="white">{text}</span>,
                    })}
                </p>
            </div>
            <div className="top-box">
                <p className="box-title ">{t('secS_app')}</p>
                <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <p className="card-text box-desc">{card?.text}</p>
                            <div className="card-img">
                                <EFPicture src={card?.img} alt={card?.text} />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="bot-box">
                <div className="left-box">
                    <p className="box-title">{t('secS_web')}</p>
                    <p className="box-desc">{t('secS_web_data')}</p>
                    {locale === 'jp' && <p className="box-tip">{t('secS_web_tip')}</p>}
                    {['us', 'ca'].includes(locale) && (
                        <Link
                            className="box-link"
                            href="https://portal.ecoflow.com/user/us/en/login"
                            target="_blank"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: t('secS_power'),
                                position: 'Product Detail_EcoFlow DELTA Ultra Pro',
                            }}
                        >
                            <span className="link-text">{t('common_learn_more')}</span>
                            <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                <path
                                    d="M5.16004 2.16602L9.25781 6.26379L5.16004 10.3616"
                                    stroke="#3F68E0"
                                    strokeWidth="1.07566"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Link>
                    )}
                    <div className="box-img">
                        <EFPicture src="/responsive/picture/delta-pro-ultra/launch/19_2.png" alt={t('secS_web')} />
                    </div>
                </div>
                <div className="right-box">
                    <div className="right-inner">
                        <p className="box-title">{t('secS_power')}</p>
                        <p className="box-desc">{t('secS_power_manager')}</p>
                        {!['br', 'mx'].includes(locale) && (
                            <Link
                                className="box-link"
                                href={
                                    locale === 'jp'
                                        ? 'https://jp.ecoflow.com/products/ecoflow-power-insight'
                                        : `https://${locale}.ecoflow.com/products/powerinsight-home-energy-manager`
                                }
                                target="_blank"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: t('secS_power'),
                                    position: 'Product Detail_EcoFlow DELTA Ultra Pro',
                                }}
                            >
                                <span className="link-text">{t('common_learn_more')}</span>
                                <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                    <path
                                        d="M5.16004 2.16602L9.25781 6.26379L5.16004 10.3616"
                                        stroke="#3F68E0"
                                        strokeWidth="1.07566"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Link>
                        )}
                        <ul className="box-lists">
                            <li className="box-list">{t('secS_power_text1')}</li>
                            <li className="box-list">{t('secS_power_text2')}</li>
                            <li className="box-list">{t('secS_power_text3')}</li>
                            {!['jp', 'us', 'mx'].includes(locale) && <li className="box-list">{t('secS_power_text4')}</li>}
                        </ul>
                        <div className="box-img">
                            <EFPicture
                                src={`/responsive/picture/delta-pro-ultra/launch/19_3${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.png`}
                                alt={t('secS_power')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
